export default __webpack_public_path__ + "static/media/image-banner-w.1b548802.webp";